import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimoniosDestacados } from '../data/testimonios';
import { Emoji } from './Emoji';
const stats = [{
  value: '6',
  label: 'Tomos listos'
}, {
  value: '6',
  label: 'Bonos incluidos'
}, {
  value: '+1000',
  label: 'personas confían'
}, {
  value: '4.9/5',
  label: 'calificación',
  emoji: '⭐'
}];
export function TestimonialStrip() {
  return <section aria-label="Prueba social" className="w-full bg-forest-950 py-10 sm:py-14" data-id="element-224" data-mp="19sd7x58lihj7">
      <div className="mx-auto w-full max-w-content px-4 sm:px-6" data-id="element-225" data-mp="1eshsp7gjdyf8">
        <dl className="mx-auto grid max-w-md grid-cols-2 items-start gap-x-6 gap-y-7 text-center lg:max-w-3xl lg:grid-cols-4" data-id="element-226" data-mp="1etssyxarwo1l">
          {stats.map(stat => <div key={stat.label} className="min-w-0" data-id="element-227" data-mp="150lqplbbxo5q">
              <dt className="sr-only" data-id="element-228" data-mp="1srzgpkm0d7nj">{stat.label}</dt>
              <dd data-id="element-229" data-mp="1sqg4c53h3gr1">
                <span className="block whitespace-nowrap font-display text-[clamp(1.5rem,7vw,3rem)] font-black leading-none tracking-tight text-cream" data-id="element-230" data-mp="1spwhqb2vo46o">
                  {stat.value}
                </span>
                <span className="mt-2 inline-flex items-center justify-center gap-1.5 text-[11px] font-semibold leading-tight text-lime-400 sm:text-sm" data-id="element-231" data-mp="1lhugfxo6dq5a">
                  {stat.label}
                  {stat.emoji ? <Emoji symbol={stat.emoji} data-id="element-232" data-mp="1vg0fm7ilki6g" /> : null}
                </span>
              </dd>
            </div>)}
        </dl>

        <ul className="mt-10 grid gap-4 sm:gap-5 lg:grid-cols-3" data-id="element-233" data-mp="296dnyazehywb">
          {testimoniosDestacados.map(item => <li key={item.initials + item.name} className="h-full" data-id="element-234" data-mp="2551xk38pd9n2">
              <figure className="flex h-full flex-col rounded-2xl border border-lime-400/15 bg-forest-900 p-4 sm:p-5" data-id="element-235" data-mp="2j64g460ho1t8">
                <div className="flex items-start gap-3 sm:gap-4" data-id="element-236" data-mp="2e7t9s59ek9fr">
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-lime-500/15 font-display text-xs font-bold text-lime-300 sm:h-11 sm:w-11" aria-hidden="true" data-id="element-237" data-mp="orbsat5ukfbu">
                    {item.initials}
                  </span>
                  <div className="min-w-0" data-id="element-238" data-mp="2ot1j6wrebnf6">
                    <span className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-239" data-mp="2ovxfyhric621">
                      {Array.from({
                    length: 5
                  }).map((_, index) => <StarIcon key={index} className="h-4 w-4 fill-gold text-gold" aria-hidden="true" data-id="element-240" data-mp="2xuri0nnlxomz" data-mpi={index} />)}
                    </span>
                    <blockquote className="mt-2 font-display text-[14px] font-bold leading-snug text-cream sm:text-[15px]" data-id="element-241" data-mp="37qcgibtgw6rz">
                      “{item.quote}”
                    </blockquote>
                  </div>
                </div>
                <figcaption className="mt-auto pt-3 text-[13px] text-cream/60 sm:pl-[56px] sm:text-sm" data-id="element-242" data-mp="3lkvd26mqcg2d">
                  — {item.name}, {item.location}
                </figcaption>
              </figure>
            </li>)}
        </ul>
      </div>
    </section>;
}